module.exports = __webpack_public_path__ + "assets/images/spanish.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/spanish.png
// module id = 407
// module chunks = 1